S.picturefeed = {
    config: {
        loop: true,
    },

    elements: {
        $swiperContainer: null,
        $swiperPagination: null,
        $image: null,
    },

    /** var {jQuery} $swiper */
    $swiper: null,

    init()
    {
        this.initSwiper();
        this.hoverImage();
    },

    /** initSwiper */
    initSwiper()
    {
        this.$swiper = new Swiper(this.elements.$swiperContainer, {
            slidesPerView: 3,
            direction: 'vertical',
            navigation: {
                nextEl: this.$module.find('.swiper-button-down'),
                prevEl: this.$module.find('.swiper-button-up'),
            },
            preloadImages: false,
            lazy: true,
        });
    },

    hoverImage()
    {
        this.elements.$image.on('mouseover', (e) =>
        {
            const $element = $(e.currentTarget);

            this.elements.$image.find('.m-overlay').removeClass('is-hover');
            $element.find('.m-overlay').addClass('is-hover');
        });
    },
};
